import React, { ReactNode, useState } from 'react';
import { OneWayInOpportunitySimpleV2Dto, OneWayInStatus } from 'src/api/v2';
import { FaIcon, FaIcons, IconButton } from '@innovationnorway/component-library';
import { hoverEnter, hoverLeave } from '../helpers';
import OpportunityCard from './OpportunityCard';

const OpportunityColumn = ({
  opportunityList,
  status,
  minimizable = false,
  name,
  onChangeStatus,
  onAddAdvisorModalOpen,
  color,
  statusLegend,
  onRecommendServicesModalOpen,
  onDeliverServicesModalOpen,
}: {
  opportunityList: OneWayInOpportunitySimpleV2Dto[];
  status?: OneWayInStatus;
  minimizable?: boolean;
  name: string;
  onChangeStatus: (id: string, status: OneWayInStatus) => void;
  onAddAdvisorModalOpen: (opportunity: OneWayInOpportunitySimpleV2Dto) => void;
  color: 'green' | 'orange' | 'gray' | 'blue';
  statusLegend?: ReactNode;
  onRecommendServicesModalOpen: (opportunity: OneWayInOpportunitySimpleV2Dto) => void;
  onDeliverServicesModalOpen: (opportunity: OneWayInOpportunitySimpleV2Dto) => void;
}) => {
  const [minimized, setMinimized] = useState(false);
  return minimized ? (
    <button
      className="clickable-wrapper display--flex padding-top--2 flex-direction--column"
      onClick={() => setMinimized(false)}
    >
      <FaIcon className="" name={FaIcons.AngleDoubleLeftLight} />
      <div className="minimized margin-top--2">{name}</div>
    </button>
  ) : (
    <section
      onDrop={(e) => {
        e.preventDefault();
        if (status) {
          const data = e.dataTransfer.getData('text/plain');
          onChangeStatus(data, status);
          hoverLeave(e);
        }
      }}
      onDragEnter={(e) => {
        hoverEnter(e);
      }}
      onDragLeave={(e) => {
        hoverLeave(e);
      }}
      onDragOver={(e) => {
        hoverEnter(e);
        e.preventDefault();
      }}
      className={`stack board__column  ${!status && 'inactive'}`}
    >
      <div className="flex justify-content--space-between">
        {statusLegend ? (
          statusLegend
        ) : (
          <div className="flex gap--1 col__name">
            <div className={`dot ${color}`}></div>
            <div className={``}>{name}</div>
          </div>
        )}
        {minimizable && (
          <IconButton
            iconName={FaIcons.AngleDoubleRightLight}
            className="mini__button"
            onClick={() => setMinimized(true)}
          >
            {'>'}
          </IconButton>
        )}
      </div>
      <div className="scrollable stack">
        {opportunityList.map((oppo) => (
          <OpportunityCard
            key={oppo.id}
            opportunity={oppo}
            onAddAdvisorModalOpen={onAddAdvisorModalOpen}
            onRecommendServicesModalOpen={onRecommendServicesModalOpen}
            onDeliverServicesModalOpen={onDeliverServicesModalOpen}
          />
        ))}
      </div>
    </section>
  );
};

export default OpportunityColumn;
